<template>
  <div>
    <div class="row">
      <div class="col-12">
        <p class="text-right">
          <router-link class="btn btn-primary" :to="{ name: 'tributes.create' }">
            <font-awesome-icon :icon="['fal', 'plus-circle']" />
            Create
          </router-link>
        </p>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <v-server-table ref="table" url="/tributes" :columns="columns" :options="options" />
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
import entity from "../../mixins/entity";
import format from "../../mixins/format";

const columns = ["name", "goal", "start", "end", "actions"];

export default {
  mixins: [entity, format],

  data() {
    return {
      columns,
      options: {
        templates: {
          start: (h, o) => this.formatLocalDate(o.start, "DD MMM YYYY"),
          end: (h, o) => this.formatLocalDate(o.end, "DD MMM YYYY"),
          actions: (h, o) => this.entityEdit(h, o, "tributes", this.$refs),
        },
      },
    };
  },
};
</script>
